const ImageCard = (props) => {
    return (
        <div className={props.className}>
            <img src={props.ImgSrc} loading='lazy' />
            <h3><a href={props.Link}>{props.ImgTitle}</a></h3>
            <p>{props.Description}</p>
        </div>
    );
};

export default ImageCard;